export const ENVIRONMENT = import.meta.env.VITE_APP_ENVIRONMENT;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

export const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
export const API_URL = import.meta.env.VITE_APP_API_URL;

export const CHECK_APP_VERSION =
  (import.meta.env.VITE_APP_CHECK_APP_VERSION ?? "true") === "true";

export const PANEL_LEGACY_URL = import.meta.env.VITE_APP_PANEL_LEGACY_URL;

export const BETA_LOCK_ENABLED = import.meta.env.VITE_APP_BETA_LOCK === "true";

export const BITE_REPLY_FEEDBACK_VISIBLE =
  (import.meta.env.VITE_APP_BITE_FEEDBACK ?? "true") === "true";
